import React, { useState, useCallback } from 'react';
import { useAuth } from '../Auth/AuthContext';
import AppMenu from './AppMenu';
import '../css/GetPrintQuote.css';

const GetPrintQuote = () => {
  const { user, isAuthorized, userRole } = useAuth();

  const [whiteInk, setWhiteInk] = useState(false);
  const [radius, setRadius] = useState('3');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [quantity, setQuantity] = useState('');
  const [shape, setShape] = useState('Round');
  const [material, setMaterial] = useState('Mirrorkote');
  const [outputText, setOutputText] = useState('');
  const [option, setOption] = useState('i) ');
  const [fontSize, setFontSize] = useState('2');

  const shopId = 2; // 1=odp ; 2=magic

  const grade1 = 110;
  const grade2 = 230;
  const grade3 = 380;
  const grade4 = 530;
  const grade5 = 730;

  const getProcessingSegment = (qtyString) => {
    return qtyString.split('+');
  };

  const replaceArrayCharacter = (segment, toReplace, replacementCharacter) => {
    return segment.map(item => item.replace(toReplace, replacementCharacter));
  };

  const getOneSheetPrice = (mat) => {
    switch (mat) {
      case 'Mirrorkote': return grade1;
      case 'Synthetic':
      case 'Synthetic (Transparent)': return grade2;
      case 'PVC (White-base)':
      case 'PVC (Transparent)':
      case 'Removable Synthetic':
      case 'Silver Synthetic':
      case 'Hologram Synthetic': return grade3;
      case 'Removable PVC (White-base)':
      case 'Removable PVC (Transparent)':
      case 'Silver PVC':
      case 'Hologram PVC': return grade4;
      case 'Window Sticker (White-base)':
      case 'Tattoo Sticker':
      case 'Floor Sticker': return grade5;
      default: return 0;
    }
  };

  const countTotalProcessingFee = (displaySegment) => {
    return displaySegment.reduce((count, item) => {
      if (item.includes('*')) {
        return count + parseInt(item.split('*')[0], 10);
      }
      return count + 1;
    }, 0) - 1;
  };

  const getDisplayQuantityFormatted = (displayArray) => {
    return displayArray.join(' + ');
  };

  const calculate = useCallback(() => {
    let paperSize = "A4";
    const bleed = 3;
    const widthEntry = parseInt(width, 10);
    const heightEntry = parseInt(height, 10);
    let output = "";

    let qtyString = quantity.replace(/ /g, '').replace(/[xX]/g, '*');
    const segment = getProcessingSegment(qtyString);
    const extraProcessingCount = countTotalProcessingFee(segment);
    const displayArray = replaceArrayCharacter(segment, /[*]/g, ' X ');
    const qty = parseInt(eval(qtyString), 10);

    const displayQuantity = getDisplayQuantityFormatted(displayArray);
    let w = widthEntry;
    let h = heightEntry;

    let oneSheetPrice = 0;
    let fullW = 287;
    let fullH = 200;
    let cut1stroke = 13;
    let pFee = 780;
    let subsequentProcessing = 300;

    output += `Quotation for ${displayQuantity} pcs ${shape} stickers :\n`;
    output += `- Material : ${material}\n`;
    if (shape === "Round") {
      output += `- Shape : Circular\n- Size : ${widthEntry}mm diameter\n`;
    } else {
      output += `- Shape : ${shape}\n- Size : ${widthEntry}mm (W) X ${heightEntry}mm (H)\n`;
    }

    // HARDCODE SPECIAL SIZES
    if (w <= 20) w = 20;
    if (h <= 20) h = 20;
    if (w === 90) w = 89;
    if (h === 90) h = 89;

    oneSheetPrice = getOneSheetPrice(material);

    if (["Round", "Rectangle (Rounded corners)", "Square (Rounded corners)", "Oval"].includes(shape)) {
      pFee = 980;
      cut1stroke = 19;
      fullW = 277;
      fullH = 190;
    } else if (shape === "Custom-shape") {
      pFee = 1200;
      cut1stroke = 23;
      fullW = 277;
      fullH = 190;
    }

    // Start calculation
    let wStrokes1 = Math.floor(fullW / (pFee === 780 ? w : w = w + bleed));
    let hStrokes1 = Math.floor(fullH / (pFee === 780 ? h : h = h + bleed));
    let totalStrokes1 = wStrokes1 + hStrokes1;
    let totalStrokesCosts1 = (totalStrokes1 + 2) * cut1stroke;
    let pcsPerSheet1 = wStrokes1 * hStrokes1;
    let unitPrice1 = Math.round((oneSheetPrice + totalStrokesCosts1) / pcsPerSheet1 * 10) / 10;

    let wStrokes2 = Math.floor(fullW / (pFee === 780 ? h : h));
    let hStrokes2 = Math.floor(fullH / (pFee === 780 ? w : w));
    let totalStrokes2 = wStrokes2 + hStrokes2;
    let totalStrokesCosts2 = (totalStrokes2 + 2) * cut1stroke;
    let pcsPerSheet2 = wStrokes2 * hStrokes2;
    let unitPrice2 = Math.round((oneSheetPrice + totalStrokesCosts2) / pcsPerSheet2 * 10) / 10;

    if (!isFinite(unitPrice1) && !isFinite(unitPrice2)) {
      paperSize = "A3";
    }

    if (paperSize === "A3") {
      // Implement A3 calculations here
      // ...
    }

    let unitPrice = Math.min(unitPrice1, unitPrice2);
    if (shopId === 2) {
      unitPrice = Math.round(unitPrice * 85 / 100 * 10) / 10;
    }

    let totalCosts = pFee + (extraProcessingCount * subsequentProcessing) + (unitPrice * qty);

    unitPrice = (unitPrice/100).toFixed(3);
    totalCosts = (totalCosts/100).toFixed(2);
    pFee = (pFee/100).toFixed(2);
    subsequentProcessing = (subsequentProcessing/100).toFixed(2);

    output += `- Kiss-cut on ${paperSize} sheets\n\n`;

    if (totalCosts >= 35.00) {
      output += `Processing fee $${pFee}`;
      if (extraProcessingCount > 0) {
        output += ` + $${subsequentProcessing} X ${extraProcessingCount}`;
      }
      output += ` + ($${unitPrice}/pcs X ${qty} pcs) = $${totalCosts}`;
    } else {
      output += `Processing fee $${pFee}`;
      if (extraProcessingCount > 0) {
        output += ` + $${subsequentProcessing} X ${extraProcessingCount}`;
      }
      output += ` + $10 surcharge for items <$35 + ($${unitPrice}/pcs X ${qty} pcs) = $${(parseFloat(totalCosts) + 10).toFixed(2)}`;
    }

    setOutputText(output);
  }, [width, height, quantity, shape, material]);

  const generateEmail = useCallback(() => {
    const absorbOutputBox = outputText.split('\n');
    let oneLine = `<font face='Arial' size=${fontSize}>`;

    absorbOutputBox.forEach((line, i) => {
      if (i === 0) {
        const [part1, part2] = line.replace("Quotation for ", "").split(":");
        if (option === "Quotation for ") {
          oneLine += `<b><u>${option}${part1.slice(0, -1)}</u> :${part2}</b><br>`;
        } else {
          oneLine += `<b>${option}<u>${part1.slice(0, -1)}</u> :${part2}</b><br>`;
        }
      } else if (i === 1 || i === 4) {
        oneLine += `<font color='#0000ff'>${line}</font><br>`;
      } else if (i === 2 || i === 3) {
        const [part1, part2] = line.split(":");
        oneLine += `<font color='#0000ff'>${part1}:<b>${part2}</b></font><br>`;
      } else if (i === 6 && option !== "Quotation for ") {
        oneLine += `${option}${line}<br>`;
      } else if (line === "" && option !== "Quotation for ") {
        // Name generator
        const qty = parseInt(quantity, 10);
        const size = shape === "Round" ? `${width}mm_` :
          (shape === "Rectangle (Rounded corners)" || shape === "Square (Rounded corners)") ?
            `${width}x${height}r${radius}mm_` : `${width}x${height}mm_`;

        let materialShort = material;
        // ... (implement material shortening logic)

        const shapeShort = shape === "Rectangle (Straight corners)" || shape === "Rectangle (Rounded corners)" ? "Rect" :
          shape === "Square (Straight corners)" || shape === "Square (Rounded corners)" ? "Square" :
          shape === "Custom-shape" ? "Custom" : shape;

        const fileName = `${qty}pcs_${size}${materialShort}_${shapeShort}.jpg`;

        if (option === "i) " || option === "") {
          oneLine += `<font color='#008000'>- <b>Final artwork : ${fileName}</b></font><br><br><b>2) Price</b><br><br>`;
        } else {
          oneLine += `<font color='#008000'>- <b>Final artwork : ${fileName}</b></font><br><br>`;
        }
      } else {
        oneLine += `${line}<br>`;
      }
    });

    oneLine += "</font>";

    const newWindow = window.open("", "", "width=960, height=540, top=270, left=480");
    newWindow.document.write(oneLine);
  }, [outputText, fontSize, option, quantity, width, height, shape, material, radius]);


  if (!user) {
    return (
      <div className="container">
        <AppMenu />
        <main className="main">
          <div className="GetPrintQuote">
            <p>Please log in to access the dashboard.</p>
          </div>
        </main>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div className="container">
        <AppMenu />
        <main className="main">
          <div className="GetPrintQuote">
            <p>You are not authorized to view this dashboard. Your role: {userRole}</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="container">
      <AppMenu />
      <main className="main">
      
        <div className="GetPrintQuote">
        <form>
          <table>
            <tbody>
                <tr>
                <td>
                    <p align="right">
                      White Ink 
                      <input type="checkbox" checked={whiteInk} onChange={(e) => setWhiteInk(e.target.checked)} />
                      Corner R:
                      <input type="text" value={radius} onChange={(e) => setRadius(e.target.value)} size="1" maxLength="3" />mm
                      <br /><br />
                      Width (mm) : 
                      <input type="text" value={width} onChange={(e) => setWidth(e.target.value)} />
                      <br /><br />
                      Height (mm) : 
                      <input type="text" value={height} onChange={(e) => setHeight(e.target.value)} />
                      <br /><br />
                      Quantity : 
                      <input type="text" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                      <br /><br />
                      Shape : {ShapePicker()}
                      <br /><br />
                      Material : {MaterialPicker()}
                    </p>
                </td>
                </tr>
            </tbody>
          </table>

          <button type="button" onClick={calculate} >Calculate</button>
          <button type="button" onClick={() => {/* Implement calculateMin */}} >Find Min</button>
          <br />

          <textarea value={outputText} onChange={(e) => setOutputText(e.target.value)}
            rows="11" cols="65" />
          <br />

          <select value={option} onChange={(e) => setOption(e.target.value)}>
            <option value="Quotation for ">Quotation</option>
            <option value="">0. n/a)</option>
            <option value="i) ">1. i)</option>
            <option value="ii) ">2. ii)</option>
            <option value="iii) ">3. iii)</option>
            <option value="iv) ">4. iv)</option>
            <option value="v) ">5. v)</option>
            <option value="vi) ">6. vi)</option>
          </select>

          <button type="button" onClick={generateEmail} >Generate Email Paragraph</button>

          <select value={fontSize} onChange={(e) => setFontSize(e.target.value)} >
            <option value="1">Font size 1</option>
            <option value="2">Font size 2</option>
            <option value="2.5">Font size 2.5</option>
            <option value="3">Font size 3</option>
            <option value="3.5">Font size 3.5</option>
            <option value="4">Font size 4</option>
            <option value="5">Font size 5</option>
          </select>
          <br /><br />
        </form>
        </div>
      </main>
    </div>
  );

  function ShapePicker() {
    return (
      <label>
        <select value={shape} onChange={(e) => setShape(e.target.value)} required>
            <option value="Round">Round</option>
            <option value="Rectangle (Straight corners)">Rectangle (Straight corners)</option>
            <option value="Rectangle (Rounded corners)">Rectangle (Rounded corners)</option>
            <option value="Square (Straight corners)">Square (Straight corners)</option>
            <option value="Square (Rounded corners)">Square (Rounded corners)</option>
            <option value="Oval">Oval</option>
            <option value="Custom-shape">Custom-shape</option>
        </select>
      </label>
    );
  }

  function MaterialPicker() {
    return (
      <label>
        <select value={material} onChange={(e) => setMaterial(e.target.value)} required>
            <option value="Mirrorkote">Mirrorkote</option>
            <option value="Synthetic">Synthetic</option>
            <option value="Synthetic (Transparent)">Synthetic (Transparent)</option>
            <option value="PVC (White-base)">PVC (White-base)</option>
            <option value="PVC (Transparent)">PVC (Transparent)</option>
            <option value="Window Sticker (White-base)">Window Sticker (White-base)</option>
            <option value="Removable Synthetic">Removable Synthetic</option>
            <option value="Removable PVC (White-base)">Removable PVC (White-base)</option>
            <option value="Removable PVC (Transparent)">Removable PVC (Transparent)</option>
            <option value="Silver Synthetic">Silver Synthetic</option>
            <option value="Silver PVC">Silver PVC</option>
            <option value="Hologram Synthetic">Hologram Synthetic</option>
            <option value="Hologram PVC">Hologram PVC</option>
            <option value="Floor Sticker">Floor Sticker</option>
            <option value="Tattoo Sticker">Tattoo Sticker</option>
        </select>
      </label>
    );
  }


};

export default GetPrintQuote;

